module.exports = __webpack_public_path__ + "img/404.5f76e018.png";